var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { NumberFormatBase, useNumericFormat } from 'react-number-format';
import { useBaseNumeric } from './useBaseNumeric';
export const NumericInput = forwardRef((_a, ref) => {
    var { value, step, min, max, onValueChange, precision, allowLeadingZeros = false, allowNegative = true, disabled = false, inputMode = 'decimal', isOnlyMouseWheel = false, onIncrement, onDecrement, format, onBlur, onKeyDown } = _a, otherProps = __rest(_a, ["value", "step", "min", "max", "onValueChange", "precision", "allowLeadingZeros", "allowNegative", "disabled", "inputMode", "isOnlyMouseWheel", "onIncrement", "onDecrement", "format", "onBlur", "onKeyDown"]);
    const { numericInputProps, formatNumber } = useBaseNumeric({
        value,
        step,
        onValueChange,
        min,
        max,
        precision,
        allowLeadingZeros,
        allowNegative,
        disabled,
        isOnlyMouseWheel,
        onIncrement,
        onDecrement,
        format,
        onBlur
    });
    const baseProps = useNumericFormat(numericInputProps);
    return (React.createElement(NumberFormatBase, Object.assign({}, baseProps, { inputMode: inputMode, format: formatNumber, onKeyDown: onKeyDown, getInputRef: ref }, otherProps)));
});
NumericInput.displayName = 'NumericInput';
